import { default as Image } from './CardImage';
import { default as Price } from './CardPrice';
import { default as Title } from './CardTitle';
import { default as Description } from './CardDescription';
import { default as Card } from './Card';

Card.Image = Image;
Card.Price = Price;
Card.Title = Title;
Card.Description = Description;

export default Card;
